import {cDisplay} from '../creator/cDisplay'
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import {cScene} from '../creator/cScene'
import {cGame} from '../creator/cGame'
import { ScreenItem } from '../creator/dataTypes';


export class gameTicketmachine extends cDisplay {

  private ccList: TicketScreenItem[]
  private index: number = 0;
  private scoreForThisGame: number = 0;

  init(){
    super.init()
    this.ccList = []

    console.log('INIT Ticket Automat');
    (this.scene as cScene).ev.addListener('action', this.handleSceneActions,this)    
  }

  handleSceneActions(command,options){
    console.log('TICXKET',options)
    this.ccList.forEach((el)=>el.clearError())
    switch (options.command ){
      case 'select_up':
        this.index --;
        if (this.index < 0) this.index = this.ccList.length-1 ;
        this.updateSelection();
        break;
      case 'select_down':
        this.index ++;
        if (this.index > this.ccList.length -1 ) this.index = 0;
        this.updateSelection();
        break;
      case 'select_a':
        this.ccList[ this.index ].mode = 1;
        break;
      case 'select_b':
        this.ccList[ this.index ].mode = 2;
        break;
      case 'evaluate':
        var res = this.ccList.map( (el:any)=>(el.isCorrect() ? '' : 'x') ).join('');
        let l = this.ccList.length;
        let c = l - this.scoreForThisGame;

        if (res.length === 0){
          let l = this.ccList.length;
          let c = l;// - this.scoreForThisGame;
          (this.scene as cScene).triggerSceneEvent('result_correct',{score:['ticket',c,l].join(':') });
        }else{
          this.scoreForThisGame = res.length;
          (this.scene as cScene).triggerSceneEvent('result_wrong');
        }
        break;
    }
  }

  
  buildScene(){
    super.buildScene();

    // building items
    var tg: cContainer = this.getByName('display_holder') as cContainer
    var dataSp: cSprite = this.getByName('DATA') as cSprite
    var dataItems = Phaser.Utils.Array.Shuffle( dataSp.modules.data._extraData );
    var wi = 459;
    var hi = 91
    var len = Math.floor(dataItems.length / 2)
    dataItems.forEach( (el:any,i)=>{
      var item = new TicketScreenItem(this.scene,el);
      item.y = ( (i % len) * hi)
      item.x = (Math.floor(i / len ) * wi)
      tg.add(item);
      this.ccList.push(item)
    });

    setTimeout(()=>{
      this.updateSelection();
    },20)
    //setup Items

  }


  updateSelection(){
    console.log(this.index)
    this.ccList.forEach( (el,i)=>{
      el.selected = i == this.index
    })
  }

  mounted(){
    
  }

}




class TicketScreenItem extends Phaser.GameObjects.Container {

  private bg: Phaser.GameObjects.Sprite
  private col: Phaser.GameObjects.Sprite
  private sel: Phaser.GameObjects.Sprite
  private error: Phaser.GameObjects.Sprite
  private txt: Phaser.GameObjects.Text

  private _mode: number = -1;
  private _data: any
 

  constructor(sc:Phaser.Scene,opt){
    super(sc)

    this._data = opt

    // make bg
    this.bg = sc.add.sprite(0,0,'ticket_screenitem','bg.png');
    this.add(this.bg);
    // make bg
    this.col = sc.add.sprite(0,0,'ticket_screenitem','select_a.png');
    this.col.visible = false
    this.add(this.col);

    
    this.sel = sc.add.sprite(0,0,'ticket_screenitem','selected.png');
    this.sel.visible = false;
    this.add(this.sel);

    var style:any =  {...cGame.current.getStyle('bodytext')}
    style.fontSize = 24;
    style.fixedWidth = 375;
    style.color = '#ffffff';
    style.wordWrap = {width:375};
    style.align = 'center';
    this.txt = sc.add.text(-200,0, opt.text,style)    
    this.add(this.txt);

    this.txt.y = - (this.txt.displayHeight / 2)

    this.error = sc.add.sprite(0,0,'ticket_screenitem','error.png');
    this.error.visible = false;
    this.add(this.error);    
  }

  public set selected(v:boolean){
    this.sel.visible = v
  }

  public get mode(){ return this._mode}
  public set mode(v:number){
    this.col.setFrame( v == 1 ? 'select_a.png' : 'select_b.png');
    this.col.visible = true;
    this._mode = v;
  }


  clearError(){
    this.error.visible = false;
  }

  isCorrect(){
    if (this._data.type != this._mode){
      this.error.visible = true
      return false
    }else{
      return true
    }
  }

}
